/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
// TODO: Fix the above issues to improve accessibility, then remove the eslint comments.
import { useTheme } from '@material-ui/core/styles';
import { AppBar, IconButton, Toolbar, Tooltip } from '@material-ui/core';
import { Help as HelpIcon, Menu as MenuIcon, Settings as SettingsIcon } from '@material-ui/icons';
import { t } from '@lingui/macro';
import { useSnackbar } from 'notistack';

import copyToClipboard, { COPY_MESSAGE } from '../../utilities/CopyToClipboardUtilities';
import Link from '../links/Link';
import { useAllowDrillIn, useIsAdminUser } from '../../stores/SessionStore';
import { useVersion } from '../../stores/EnvironmentStore';
import { useHelpUrl } from '../../utilities/HelpUtilities';
import useStyles from './TopNavStyles';
import useSideNavState from '../../stores/SideNavStateStore';
import { useAboutDialog } from '../about-dialog/AboutDialog';
import UserMenu from '../user-menu/UserMenu';
import GlobalSearch from '../global-search/GlobalSearch';

const defaultPlacement = 'bottom';

export default function TopNav() {
    const [sideNavState, sideNavStateActions] = useSideNavState();
    const theme = useTheme();
    const classes = useStyles();
    const [isAdminUser] = useIsAdminUser();
    const [version] = useVersion();
    const helpHref = useHelpUrl();
    const [aboutDialog, showAboutDialog] = useAboutDialog();
    const { enqueueSnackbar } = useSnackbar();
    const [canDrillIn] = useAllowDrillIn();

    function handleClick() {
        sideNavStateActions.setOpen(!sideNavState.open);
    }

    function quickCopyVersion() {
        copyToClipboard(version);
        enqueueSnackbar(COPY_MESSAGE);
    }

    return (
        <AppBar id="top-nav" position="relative" elevation={0} className={classes.topNav}>
            <Toolbar>
                <IconButton
                    id="side-nav-menu"
                    color="inherit"
                    onClick={handleClick}
                    edge="start"
                    className={classes.menuButton}
                >
                    <MenuIcon />
                </IconButton>

                <div className={classes.logoContainer}>
                    <img
                        src={theme.productLogo}
                        className={classes.productLogo}
                        alt={theme.productName}
                        title={version}
                        onClick={(e) => (e.shiftKey ? quickCopyVersion() : showAboutDialog())}
                    />
                    {aboutDialog}
                </div>

                <div className={classes.actionContainer}>
                    <ActionItem>{canDrillIn && <GlobalSearch />}</ActionItem>

                    {isAdminUser && (
                        <ActionItem>
                            <Tooltip title={t`Administration`} placement={defaultPlacement}>
                                <Link to="/admin/">
                                    <SettingsIcon color="inherit" />
                                </Link>
                            </Tooltip>
                        </ActionItem>
                    )}
                    <ActionItem>
                        <Tooltip title={t`Help Center`} placement={defaultPlacement}>
                            <a href={helpHref} target="_">
                                <HelpIcon />
                            </a>
                        </Tooltip>
                    </ActionItem>

                    <ActionItem>
                        <UserMenu />
                    </ActionItem>
                </div>
            </Toolbar>
        </AppBar>
    );
}

function ActionItem(props) {
    const { children } = props;

    return <div className="action-item">{children}</div>;
}
